"use client"

import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import PropTypes from "prop-types";
import Link from "next/link";

ResourcesSection.propTypes = {
  heading: PropTypes.string.isRequired,
  img1: PropTypes.string.isRequired,
  img2: PropTypes.string.isRequired,
  img3: PropTypes.string.isRequired,
  date1: PropTypes.string.isRequired,
  date2: PropTypes.string.isRequired,
  date3: PropTypes.string.isRequired,
  title1: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  title3: PropTypes.string.isRequired,
  content1: PropTypes.string.isRequired,
  content2: PropTypes.string.isRequired,
  content3: PropTypes.string.isRequired,
  calenderIcon: PropTypes.string.isRequired,
  url1: PropTypes.string,
  url2: PropTypes.string,
  url3: PropTypes.string,
};

function ResourcesSection({
  calenderIcon,
  blok
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });


  let heading= blok.resource_section?.find(item=>item.component=="Heading") || {}
  let blogs= blok.resource_section?.filter(item=>item.component!=="Heading") || []

  return (
    <div className="flex flex-col  items-center px-[24px] lg:px-0 w-full">
      <div ref={ref} className="flex max-w-7xl flex-col items-center text-center w-full py-14 xl:px-14 2xl:px-0">
        <h1 className="font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px]
        md:text-[48px] font-bold mb-8 md:mb-24 leading-normal">
          {heading.header}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index === 0 ? -100 : index === 2 ? 100 : 0 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2 * (index + 1) }}
                className="bg-white shadow-lg rounded-3xl flex flex-col items-center text-center px-5 py-5 space-y-4"
              >
                <img src={item.image?.filename} className="w-full aspect-square object-cover rounded-lg" alt={`Resource ${index + 1}`} />

                <div className="flex items-center gap-2">
                  <img src={calenderIcon} alt="Calendar Icon" className="w-5 h-5" />
                  <p className="text-sm font-lato">{item.date}</p>
                </div>

                <Link href={"/"+item.url?.cached_url} target="_blank" className="text-[#49378F] font-lato font-bold text-lg md:text-xl hover:underline">
                  {item.title}
                </Link>

                <p className="text-sm md:text-base font-lato text-gray-600">{item.description}</p>
              </motion.div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default ResourcesSection;
